import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { VehicleRepo } from 'src/app/repositories/vehicle-repo';
import { Vehicle } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-delete-vehicle',
    templateUrl: './modal-delete-vehicle.component.html',
    styleUrls: ['./modal-delete-vehicle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteVehicleComponent implements OnDestroy {
  loading = false;
  deleteSuccess: any;
  deleteError: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public vehicle: Vehicle,
    private vehicleRepo: VehicleRepo,
    private translate: TranslateService,
    private router: Router
  ) {}

  deleteVehicle() {
    this.loading = true;
    this.vehicleRepo
      .deleteVehicle(this.vehicle.uid).toPromise()
        .then((response: any) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant('vehicles.delete.success');
        })
        .catch((error: any) => {
          this.loading = false;
          this.deleteError = this.translate.instant('vehicles.delete.error');
        });
  }

  ngOnDestroy() {
  }
}
